import script from "./GradeItemsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeItemsTable.vue?vue&type=script&setup=true&lang=js"

import "./GradeItemsTable.vue?vue&type=style&index=0&id=28d2ce02&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d2ce02"]])

export default __exports__